// Bootstrap 4.5.0 CSS is loaded via <link> in public/index.html
// Do NOT import bootstrap CSS from node_modules (v5.x) — it conflicts with the v4 already loaded
import './setPublicPath';

import('./bootstrap');
